module.exports = __webpack_public_path__ + "img/pause.f08ddf2d.svg";